import React, { useState, useEffect, useCallback } from "react";
import { format } from "date-fns";
import { Segment, Label, Icon, Statistic, Grid, Responsive, Tab, TabProps, Embed, Button, Divider, Image } from "semantic-ui-react";

import DynamicRepository from "../../Repositories/DynamicRepository";
import TemplateMain from "../../components/TemplateMain";

import "react-big-calendar/lib/css/react-big-calendar.css";
import Schedule from "./Schedule/Index";
import { Link } from "react-router-dom";
import ImageZoom from "../../components/ImageZoom";

interface ITotalPessoa {
    Ativos: number;
    Inativos: number;
    Pendentes: number;
    Devendo: number;
}

interface ITotalKits {
    EstocadoNovo?: number;
    EstocadoAcerto?: number;
    GerenteSetor?: number;
    RepresentanteNovo: number;
    RepresentanteAcerto: number;
    Revendedor: number;
    RevendedorAcerto: number;
    PreConferido?: number;
    NaoRetornou?: number;
    ConferidoErrado?: number;
    Devendo?: number;
    Finalizado?: number;
}

interface State {
    gerenteRegional: ITotalPessoa;
    gerenteSetor: ITotalPessoa;
    representante: ITotalPessoa;
    revendedor: ITotalPessoa;
    kits: ITotalKits;
}

const AdminItems: React.FC = () => {

    const [state, setState] = useState<State>();
    const [loading, setLoading] = useState<boolean>(true);
    const [activeTabIndex, setActiveTabIndex] = useState<number>(0);

    const loadTotalGeral = useCallback(async () => {
        setLoading(true);
        const response = await DynamicRepository.DynamicTotals([
            {
                dynamicType: "GR",
                returnCode: "GRATI",
                filter: "Status == 1 && Devedor == 0"
            },
            {
                dynamicType: "GR",
                returnCode: "GRINA",
                filter: "Status == 0 && Devedor == 0"
            },
            {
                dynamicType: "GR",
                returnCode: "GRPEN",
                filter: "Status == 2 && Devedor == 0"
            },
            {
                dynamicType: "GR",
                returnCode: "GRDEV",
                filter: "Devedor == 1"
            },
            {
                dynamicType: "GS",
                returnCode: "GSATI",
                filter: "Status == 1 && Devedor == 0"
            },
            {
                dynamicType: "GS",
                returnCode: "GSINA",
                filter: "Status == 0 && Devedor == 0"
            },
            {
                dynamicType: "GS",
                returnCode: "GSPEN",
                filter: "Status == 2 && Devedor == 0"
            },
            {
                dynamicType: "GS",
                returnCode: "GSDEV",
                filter: "Devedor == 1"
            },
            {
                dynamicType: "RP",
                returnCode: "RPATI",
                filter: "Status == 1 && Devedor == 0"
            },
            {
                dynamicType: "RP",
                returnCode: "RPINA",
                filter: "Status == 0 && Devedor == 0"
            },
            {
                dynamicType: "RP",
                returnCode: "RPPEN",
                filter: "Status == 2 && Devedor == 0"
            },
            {
                dynamicType: "RP",
                returnCode: "RPDEV",
                filter: "Devedor == 1"
            },
            {
                dynamicType: "RV",
                returnCode: "RVATI",
                filter: "Status == 1 && Devedor == 0"
            },
            {
                dynamicType: "RV",
                returnCode: "RVINA",
                filter: "Status == 0 && Devedor == 0"
            },
            {
                dynamicType: "RV",
                returnCode: "RVPEN",
                filter: "Status == 2 && Devedor == 0"
            },
            {
                dynamicType: "RV",
                returnCode: "RVDEV",
                filter: "Devedor == 1"
            },
            {
                dynamicType: "KT",
                returnCode: "KTESTN",
                filter: "StatusKit == 0 && Tipo == 0"
            },
            {
                dynamicType: "KT",
                returnCode: "KTESTA",
                filter: "StatusKit == 0 && Tipo == 1"
            },
            {
                dynamicType: "KT",
                returnCode: "KTGES",
                filter: "StatusKit == 1"
            },
            {
                dynamicType: "KT",
                returnCode: "KTREPN",
                filter: "StatusKit == 2 && Tipo = 0"
            },
            {
                dynamicType: "KT",
                returnCode: "KTREPA",
                filter: "StatusKit == 2 && Tipo = 1"
            },
            {
                dynamicType: "KT",
                returnCode: "KTREV",
                filter: "StatusKit == 3 && Tipo == 0"
            },
            {
                dynamicType: "KT",
                returnCode: "KTREVACT",
                filter: "StatusKit == 3 && Tipo == 1"
            },
            {
                dynamicType: "KT",
                returnCode: "KTPRE",
                filter: "StatusKit == 4"
            },
            {
                dynamicType: "KT",
                returnCode: "KTNRE",
                filter: "Estado == 2"
            },
            {
                dynamicType: "KT",
                returnCode: "KTCFE",
                filter: "StatusKit == 5"
            },
            {
                dynamicType: "KT",
                returnCode: "KTDEV",
                filter: "Estado == 1"
            },
            {
                dynamicType: "KT",
                returnCode: "KTFIN",
                filter: "StatusKit == 8"
            },
        ]);

        setState({
            gerenteRegional: {
                Ativos: response.GRATI,
                Inativos: response.GRINA,
                Pendentes: response.GRPEN,
                Devendo: response.GRDEV
            },
            gerenteSetor: {
                Ativos: response.GSATI,
                Inativos: response.GSINA,
                Pendentes: response.GSPEN,
                Devendo: response.GSDEV
            },
            representante: {
                Ativos: response.RPATI,
                Inativos: response.RPINA,
                Pendentes: response.RPPEN,
                Devendo: response.RPDEV
            },
            revendedor: {
                Ativos: response.RVATI,
                Inativos: response.RVINA,
                Pendentes: response.RVPEN,
                Devendo: response.RVDEV
            },
            kits: {
                EstocadoNovo: response.KTESTN,
                EstocadoAcerto: response.KTESTA,
                GerenteSetor: response.KTGES,
                RepresentanteNovo: response.KTREPN,
                RepresentanteAcerto: response.KTREPA,
                Revendedor: response.KTREV,
                RevendedorAcerto: response.KTREVACT,
                PreConferido: response.KTPRE,
                NaoRetornou: response.KTNRE,
                ConferidoErrado: response.KTCFE,
                Devendo: response.KTDEV,
                Finalizado: response.KTFIN
            }
        });
        setLoading(false);
    }, []);

    const loadTotalMensal = useCallback(async () => {
        setLoading(true);
        const response = await DynamicRepository.DynamicTotals([
            {
                dynamicType: "GR",
                returnCode: "GRATI",
                filter: `Data >= "${format(new Date(), "yyyy-MM-01")}" && Status == 1 && Devedor == 0`
            },
            {
                dynamicType: "GR",
                returnCode: "GRINA",
                filter: `Data >= "${format(new Date(), "yyyy-MM-01")}" && Status == 0 && Devedor == 0`
            },
            {
                dynamicType: "GR",
                returnCode: "GRPEN",
                filter: `Data >= "${format(new Date(), "yyyy-MM-01")}" && Status == 2 && Devedor == 0`
            },
            {
                dynamicType: "GR",
                returnCode: "GRDEV",
                filter: `Data >= "${format(new Date(), "yyyy-MM-01")}" && Devedor == 1`
            },
            {
                dynamicType: "GS",
                returnCode: "GSATI",
                filter: `Data >= "${format(new Date(), "yyyy-MM-01")}" && Status == 1 && Devedor == 0`
            },
            {
                dynamicType: "GS",
                returnCode: "GSINA",
                filter: `Data >= "${format(new Date(), "yyyy-MM-01")}" && Status == 0 && Devedor == 0`
            },
            {
                dynamicType: "GS",
                returnCode: "GSPEN",
                filter: `Data >= "${format(new Date(), "yyyy-MM-01")}" && Status == 2 && Devedor == 0`
            },
            {
                dynamicType: "GS",
                returnCode: "GSDEV",
                filter: `Data >= "${format(new Date(), "yyyy-MM-01")}" && Devedor == 1`
            },
            {
                dynamicType: "RP",
                returnCode: "RPATI",
                filter: `Data >= "${format(new Date(), "yyyy-MM-01")}" && Status == 1 && Devedor == 0`
            },
            {
                dynamicType: "RP",
                returnCode: "RPINA",
                filter: `Data >= "${format(new Date(), "yyyy-MM-01")}" && Status == 0 && Devedor == 0`
            },
            {
                dynamicType: "RP",
                returnCode: "RPPEN",
                filter: `Data >= "${format(new Date(), "yyyy-MM-01")}" && Status == 2 && Devedor == 0`
            },
            {
                dynamicType: "RP",
                returnCode: "RPDEV",
                filter: `Data >= "${format(new Date(), "yyyy-MM-01")}" && Devedor == 1`
            },
            {
                dynamicType: "RV",
                returnCode: "RVATI",
                filter: `Data >= "${format(new Date(), "yyyy-MM-01")}" && Status == 1 && Devedor == 0`
            },
            {
                dynamicType: "RV",
                returnCode: "RVINA",
                filter: `Data >= "${format(new Date(), "yyyy-MM-01")}" && Status == 0 && Devedor == 0`
            },
            {
                dynamicType: "RV",
                returnCode: "RVPEN",
                filter: `Data >= "${format(new Date(), "yyyy-MM-01")}" && Status == 2 && Devedor == 0`
            },
            {
                dynamicType: "RV",
                returnCode: "RVDEV",
                filter: `Data >= "${format(new Date(), "yyyy-MM-01")}" && Devedor == 1`
            },
            {
                dynamicType: "KT",
                returnCode: "KTESTN",
                filter: `StatusKit == 0 && Tipo == 0`
            },
            {
                dynamicType: "KT",
                returnCode: "KTESTA",
                filter: `StatusKit == 0 && Tipo == 1`
            },
            {
                dynamicType: "KT",
                returnCode: "KTGES",
                filter: `StatusKit == 1`
            },
            {
                dynamicType: "KT",
                returnCode: "KTREPN",
                filter: `StatusKit == 2 && Tipo == 0`
            },
            {
                dynamicType: "KT",
                returnCode: "KTREPA",
                filter: `StatusKit == 2 && Tipo == 1`
            },
            {
                dynamicType: "KT",
                returnCode: "KTREV",
                filter: `DataEntrega >= "${format(new Date(), "yyyy-MM-01")}" && StatusKit == 3 && Tipo == 0`
            },
            {
                dynamicType: "KT",
                returnCode: "KTREVACT",
                filter: `DataEntrega >= "${format(new Date(), "yyyy-MM-01")}" && StatusKit == 3 && Tipo == 1`
            },
        ]);

        setState({
            gerenteRegional: {
                Ativos: response.GRATI,
                Inativos: response.GRINA,
                Pendentes: response.GRPEN,
                Devendo: response.GRDEV
            },
            gerenteSetor: {
                Ativos: response.GSATI,
                Inativos: response.GSINA,
                Pendentes: response.GSPEN,
                Devendo: response.GSDEV
            },
            representante: {
                Ativos: response.RPATI,
                Inativos: response.RPINA,
                Pendentes: response.RPPEN,
                Devendo: response.RPDEV
            },
            revendedor: {
                Ativos: response.RVATI,
                Inativos: response.RVINA,
                Pendentes: response.RVPEN,
                Devendo: response.RVDEV
            },
            kits: {
                EstocadoNovo: response.KTESTN,
                EstocadoAcerto: response.KTESTA,
                GerenteSetor: response.KTGES,
                RepresentanteNovo: response.KTREPN,
                RepresentanteAcerto: response.KTREPA,
                Revendedor: response.KTREV,
                RevendedorAcerto: response.KTREVACT
            }
        });
        setLoading(false);
    }, []);

    const handleTabChange = useCallback((event: React.MouseEvent<HTMLDivElement, MouseEvent>, { activeIndex }: TabProps) => {
        setActiveTabIndex(activeIndex as number);
    }, []);

    useEffect(() => {
        if (activeTabIndex === 0) {
            loadTotalMensal();
        }
        else {
            loadTotalGeral();
        }
    }, [activeTabIndex, loadTotalGeral, loadTotalMensal]);

    const renderKit = (
        <>
            {activeTabIndex === 1 &&
                <>
                    <Statistic>
                        <Statistic.Value>
                            {`${state?.kits.EstocadoNovo || 0}/${state?.kits.EstocadoAcerto || 0}`}
                        </Statistic.Value>
                        <Statistic.Label>
                            <Icon name="box" />
                            {" "}Est. Novo/Acerto
                        </Statistic.Label>
                    </Statistic>
                    <Statistic>
                        <Statistic.Value>
                            {state?.kits.GerenteSetor || 0}
                        </Statistic.Value>
                        <Statistic.Label>
                            <Icon name="user" color="pink" />
                            {" "}Ger. Setor
                        </Statistic.Label>
                    </Statistic>
                    <Statistic>
                        <Statistic.Value>
                            {`${state?.kits.RepresentanteNovo || 0}/${state?.kits.RepresentanteAcerto || 0}`}
                        </Statistic.Value>
                        <Statistic.Label>
                            <Icon name="id badge" color="violet" />
                            {" "}Rep. Novo/Acerto
                        </Statistic.Label>
                    </Statistic>
                    <Statistic>
                        <Statistic.Value>
                            {state?.kits.Revendedor || 0}
                        </Statistic.Value>
                        <Statistic.Label>
                            <Icon name="street view" color="teal" />
                            {" "}Kit's Novos
                        </Statistic.Label>
                    </Statistic>
                    <Statistic>
                        <Statistic.Value>
                            {state?.kits.PreConferido || 0}
                        </Statistic.Value>
                        <Statistic.Label>
                            <Icon name="stopwatch" color="blue" />
                            {" "}Pré Conf.
                        </Statistic.Label>
                    </Statistic>
                    <Statistic>
                        <Statistic.Value>
                            {state?.kits.NaoRetornou || 0}
                        </Statistic.Value>
                        <Statistic.Label>
                            <Icon name="thumbs down" color="black" />
                            {" "}Não retornou
                        </Statistic.Label>
                    </Statistic>
                    <Statistic>
                        <Statistic.Value>
                            {state?.kits.RevendedorAcerto || 0}
                        </Statistic.Value>
                        <Statistic.Label>
                            <Icon name="hand peace outline" color="purple" />
                            {" "}Kit's Acerto
                        </Statistic.Label>
                    </Statistic>
                    <Statistic>
                        <Statistic.Value>
                            {state?.kits.Devendo || 0}
                        </Statistic.Value>
                        <Statistic.Label>
                            <Icon name="user times" color="red" />
                            {" "}Devendo
                        </Statistic.Label>
                    </Statistic>
                    <Statistic>
                        <Statistic.Value>
                            {state?.kits.Finalizado || 0}
                        </Statistic.Value>
                        <Statistic.Label>
                            <Icon name="check" color="green" />
                            {" "}Finalizado
                        </Statistic.Label>
                    </Statistic>
                </>
            }
            {activeTabIndex === 0 &&
                <>
                    <Statistic>
                        <Statistic.Value>
                            {`${state?.kits.EstocadoNovo || 0}/${state?.kits.EstocadoAcerto || 0}`}
                        </Statistic.Value>
                        <Statistic.Label>
                            <Icon name="box" />
                            {" "}Est. Novo/Acerto
                        </Statistic.Label>
                    </Statistic>
                    <Statistic>
                        <Statistic.Value>
                            {state?.kits.GerenteSetor || 0}
                        </Statistic.Value>
                        <Statistic.Label>
                            <Icon name="user" color="pink" />
                            {" "}Ger. Setor
                        </Statistic.Label>
                    </Statistic>
                    <Statistic>
                        <Statistic.Value>
                            {`${state?.kits.RepresentanteNovo || 0}/${state?.kits.RepresentanteAcerto || 0}`}
                        </Statistic.Value>
                        <Statistic.Label>
                            <Icon name="id badge" color="violet" />
                            {" "}Rep. Novo/Acerto
                        </Statistic.Label>
                    </Statistic>
                    <Statistic as={Link} to={"/agentmonth"} >
                        <Statistic.Value>
                            {state?.kits.Revendedor || 0}
                        </Statistic.Value>
                        <Statistic.Label>
                            <Icon name="street view" color="teal" />
                            {" "}Kit's Novos
                        </Statistic.Label>
                    </Statistic>
                    <Statistic>
                        <Statistic.Value>
                            {state?.kits.RevendedorAcerto || 0}
                        </Statistic.Value>
                        <Statistic.Label>
                            <Icon name="hand peace outline" color="purple" />
                            {" "}Kit's Acerto
                        </Statistic.Label>
                    </Statistic>

                </>
            }
        </>
    );

    const content = (
        <Grid columns="2" doubling>
            <Grid.Row>
                <Grid.Column width="16">
                    <Tab
                        menu={{ secondary: true, pointing: true }}
                        panes={[{ menuItem: "Mensal" }, { menuItem: "Geral" }, { menuItem: "Calendário" }]}
                        activeIndex={activeTabIndex}
                        onTabChange={handleTabChange}
                    />
                </Grid.Column>
            </Grid.Row>
            
            {(activeTabIndex === 0 || activeTabIndex === 1) &&
                <>
                    <Grid.Row>
                        <Grid.Column width="16">
                            <Segment color="purple" raised>
                                <Label ribbon content="Kits" size="large" color="purple" />
                                <Responsive as={Statistic.Group} {...Responsive.onlyComputer} widths={activeTabIndex === 0 ? "2" : "3"} size="small">
                                    {renderKit}
                                </Responsive>
                                <Responsive as={Statistic.Group} {...Responsive.onlyMobile} widths="2" size="small">
                                    {renderKit}
                                </Responsive>
                            </Segment>
                        </Grid.Column>
                    </Grid.Row>

                    <Grid.Row>
                        <Grid.Column>
                            <Segment color="pink" raised>
                                <Label ribbon content="Gerentes regionais" size="large" color="pink" />
                                <Statistic.Group widths="two" size="small">
                                    <Statistic>
                                        <Statistic.Value>
                                            {state?.gerenteRegional.Ativos || 0}
                                        </Statistic.Value>
                                        <Statistic.Label>
                                            <Icon name="check" color="pink" />
                                            {" "}Ativos
                                        </Statistic.Label>
                                    </Statistic>
                                    <Statistic>
                                        <Statistic.Value>
                                            {state?.gerenteRegional.Inativos || 0}
                                        </Statistic.Value>
                                        <Statistic.Label>
                                            <Icon name="times" color="grey" />
                                            {" "}Inativos
                                        </Statistic.Label>
                                    </Statistic>
                                    <Statistic>
                                        <Statistic.Value>
                                            {state?.gerenteRegional.Pendentes || 0}
                                        </Statistic.Value>
                                        <Statistic.Label>
                                            <Icon name="clock" color="orange" />
                                            {" "}Pendentes
                                        </Statistic.Label>
                                    </Statistic>
                                    <Statistic>
                                        <Statistic.Value>
                                            {state?.gerenteRegional.Devendo || 0}
                                        </Statistic.Value>
                                        <Statistic.Label>
                                            <Icon name="user times" color="red" />
                                            {" "}Devendo
                                        </Statistic.Label>
                                    </Statistic>
                                </Statistic.Group>
                            </Segment>
                        </Grid.Column>
                        <Grid.Column>
                            <Segment color="pink" raised>
                                <Label ribbon content="Gerentes de setor" size="large" color="pink" />
                                <Statistic.Group widths="two" size="small">
                                    <Statistic>
                                        <Statistic.Value>
                                            {state?.gerenteSetor.Ativos || 0}
                                        </Statistic.Value>
                                        <Statistic.Label>
                                            <Icon name="check" color="pink" />
                                            {" "}Ativos
                                        </Statistic.Label>
                                    </Statistic>
                                    <Statistic>
                                        <Statistic.Value>
                                            {state?.gerenteSetor.Inativos || 0}
                                        </Statistic.Value>
                                        <Statistic.Label>
                                            <Icon name="times" color="grey" />
                                            {" "}Inativos
                                        </Statistic.Label>
                                    </Statistic>
                                    <Statistic>
                                        <Statistic.Value>
                                            {state?.gerenteSetor.Pendentes || 0}
                                        </Statistic.Value>
                                        <Statistic.Label>
                                            <Icon name="clock" color="orange" />
                                            {" "}Pendentes
                                        </Statistic.Label>
                                    </Statistic>
                                    <Statistic>
                                        <Statistic.Value>
                                            {state?.gerenteSetor.Devendo || 0}
                                        </Statistic.Value>
                                        <Statistic.Label>
                                            <Icon name="user times" color="red" />
                                            {" "}Devendo
                                        </Statistic.Label>
                                    </Statistic>
                                </Statistic.Group>
                            </Segment>
                        </Grid.Column>
                    </Grid.Row>

                    <Grid.Row>
                        <Grid.Column>
                            <Segment color="pink" raised>
                                <Label ribbon content="Representantes" size="large" color="pink" />
                                <Statistic.Group widths="two" size="small">
                                    <Statistic>
                                        <Statistic.Value>
                                            {state?.representante.Ativos || 0}
                                        </Statistic.Value>
                                        <Statistic.Label>
                                            <Icon name="check" color="pink" />
                                            {" "}Ativos
                                        </Statistic.Label>
                                    </Statistic>
                                    <Statistic>
                                        <Statistic.Value>
                                            {state?.representante.Inativos || 0}
                                        </Statistic.Value>
                                        <Statistic.Label>
                                            <Icon name="times" color="grey" />
                                            {" "}Inativos
                                        </Statistic.Label>
                                    </Statistic>
                                    <Statistic>
                                        <Statistic.Value>
                                            {state?.representante.Pendentes || 0}
                                        </Statistic.Value>
                                        <Statistic.Label>
                                            <Icon name="clock" color="orange" />
                                            {" "}Pendentes
                                        </Statistic.Label>
                                    </Statistic>
                                    <Statistic>
                                        <Statistic.Value>
                                            {state?.representante.Devendo || 0}
                                        </Statistic.Value>
                                        <Statistic.Label>
                                            <Icon name="user times" color="red" />
                                            {" "}Devendo
                                        </Statistic.Label>
                                    </Statistic>
                                </Statistic.Group>
                            </Segment>
                        </Grid.Column>
                        <Grid.Column>
                            <Segment color="pink" raised>
                                <Label ribbon content="Revendedores" size="large" color="pink" />
                                <Statistic.Group widths="two" size="small">
                                    <Statistic>
                                        <Statistic.Value>
                                            {state?.revendedor.Ativos || 0}
                                        </Statistic.Value>
                                        <Statistic.Label>
                                            <Icon name="check" color="pink" />
                                            {" "}Ativos
                                        </Statistic.Label>
                                    </Statistic>
                                    <Statistic>
                                        <Statistic.Value>
                                            {state?.revendedor.Inativos || 0}
                                        </Statistic.Value>
                                        <Statistic.Label>
                                            <Icon name="times" color="grey" />
                                            {" "}Inativos
                                        </Statistic.Label>
                                    </Statistic>
                                    <Statistic>
                                        <Statistic.Value>
                                            {state?.revendedor.Pendentes || 0}
                                        </Statistic.Value>
                                        <Statistic.Label>
                                            <Icon name="clock" color="orange" />
                                            {" "}Pendentes
                                        </Statistic.Label>
                                    </Statistic>
                                    <Statistic>
                                        <Statistic.Value>
                                            {state?.revendedor.Devendo || 0}
                                        </Statistic.Value>
                                        <Statistic.Label>
                                            <Icon name="user times" color="red" />
                                            {" "}Devendo
                                        </Statistic.Label>
                                    </Statistic>
                                </Statistic.Group>
                            </Segment>
                        </Grid.Column>
                    </Grid.Row>
                </>
            }
            {activeTabIndex === 2 &&
                <Schedule isAdmin />
            }
        </Grid>
    );


    return (
        <TemplateMain
            loading={loading}
            content={content}
        />
    );
};

export default AdminItems;
